import { z } from 'zod';
export const DSLTermsQueryDTO = z.object({
  terms: z.record(
    z.string(),
    z.array(z.union([z.string(), z.number(), z.boolean()])),
  ),
});

export type DSLTermsQuery = z.infer<typeof DSLTermsQueryDTO>;